import React from "react";
//import { ReactTyped } from "react-typed";
import Typewriter from "../components/Typewriter";
const PurposeSection: React.FC = () => {
  return (
    <section className="purpose">
      <div className="hero-border">
        <div className="purpose-container">
          {/* <p className="purpose-label">THE PURPOSE OF HOB</p> */}

          <h2 className="purpose-title">
            Bombay is not a place you leave behind.
            <br className="desktop-break" />
            It's a rhythm you carry, a hunger that returns.
          </h2>

          <div className="purpose-image-wrapper">
            <div className="purpose-image-container">
              <picture>
                <source media="(max-width: 768px)" srcSet="mpurpose.png" />
                <img
                  src="purpose.jpg"
                  alt="Bombay heritage"
                  className="purpose-image"
                />
              </picture>
            </div>
            <div className="purpose-overlay">
              <Typewriter
                text={`House of Bombay brings the spirit
of the city to the table`}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PurposeSection;
